/**
 * Route path segments, migrated from legacy `root/routing/routing.consts.ts`
 * (decision D17 — the pattern stays; 140 route definitions reference it).
 *
 * These are segments, not full routes: a route is composed from them, e.g.
 * `${PATHS.CLIENTS}/${PATHS.LIST}`. Changing a value changes a URL users have
 * bookmarked, so treat them as part of the public contract.
 *
 * Not migrated: the legacy UI Guide segments (32 of them — decision D3, the
 * starter has its own UI Guide) and `OCCASIONAL_LAYOUTS` (no screen leads
 * there, §5.5).
 */
export const PATHS = {
  ADDITIONAL: 'additional',
  ALL: 'all',
  APP_SETTINGS: 'app-settings',
  AUTH: 'auth',
  CHANNELS_TV: 'channels-tv',
  CLIENTS: 'clients',
  CLIENTS_LIST: 'clients-list',
  CLIENT_DETAILS: 'client-contract-details',
  CONTRACT_CALCULATOR: 'contract-calculator',
  CUSTOM_PAGES: 'custom-pages',
  DASHBOARD: 'dashboard',
  DELETE: 'delete',
  DETAILS: 'details',
  DEVICES: 'devices',
  DEVICES_LIST: 'devices-list',
  EDIT: 'edit',
  ERROR_404: '404',
  FAQ: 'faq',
  FILES: 'files',
  GENERAL: 'general',
  GROUPS: 'groups',
  HIBOX: 'hibox',
  INIT_ERROR: 'init-error',
  INSTALLATION_ACTIVATION: 'installation-activation',
  INVOICES: 'invoices',
  LANGUAGE_SUPPORT: 'language-support',
  LIST: 'list',
  LIST_DELETING: 'list-deleting',
  LOGOUT: 'logout',
  MAIN: 'main',
  MANAGEMENT: 'management',
  NEW: 'new',
  NO_PERMISSIONS: 'no-permissions',
  OFFERS: 'offers',
  ORDERS: 'orders',
  PAYMENTS: 'payments',
  PAYMENTS_LIST: 'payments-list',
  PERMISSIONS: 'permissions',
  PRODUCTS: 'products',
  PUBLIC_PAGES: 'public-pages',
  REGULATIONS: 'regulations',
  ROLES: 'roles',
  SETTINGS: 'settings',
  SIGN_IN: 'sign-in',
  TRANSLATIONS: 'translations',
  USER: 'user',
  USERS: 'users',
} as const;

export type PathSegment = (typeof PATHS)[keyof typeof PATHS];
